import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../store/root-reducer';
import {
  getContactListByViewIdRequest,
  getFilterViewListRequest,
  getProspectFiltersFieldsListRequest,
  getProspectListCountRequest,
  saveProspectFiltersViewRequest,
  updateProspectFiltersViewRequest,
} from '../../extra-actions';

import ProspectFiltersModal from './prospect-filters-modal';
import {
  removedSelectedSavedView,
  resetFilterGroupLogic,
  resetGetProspectFiltersFieldsListRequest,
  resetSaveProspectFiltersViewRequest,
  resetUpdateProspectFiltersViewRequest,
  setFilters,
  setProspectViewIdFilter,
  setShouldFetchInitialList,
} from '../../prospect-slice';
import {
  FilterGroupLogicPayload,
  Filters,
  ProspectFiltersSaveViewPayload,
  ProspectFiltersUpdateViewPayload,
  ProspectListPayload,
} from '../../types';

import { getTeamsRequest } from '../../../settings/components/users-and-teams/extra-actions';
import { FilterGroup } from './types';

const mapStateToProps = (state: RootState) => ({
  filters: state.prospect.filters,

  prospectFiltersFieldsList: state.prospect.prospectFiltersFieldsList,

  selectedSavedView: state.prospect.selectedSavedView,

  teamsList: state.usersAndTeams.teams,

  getTeamsListRequestStatus: state.usersAndTeams.getTeamsRequest.status,

  fields: state.prospect.fields,

  getProspectFiltersFieldsListRequestStatus:
    state.prospect.getProspectFiltersFieldsListRequest.status,
  getProspectFiltersFieldsListRequestError:
    state.prospect.getProspectFiltersFieldsListRequest.error,

  saveProspectFiltersViewRequestStatus:
    state.prospect.saveProspectFiltersViewRequest.status,
  saveProspectFiltersViewRequestError:
    state.prospect.saveProspectFiltersViewRequest.error,

  updateProspectFiltersViewRequestStatus:
    state.prospect.updateProspectFiltersViewRequest.status,
  updateProspectFiltersViewRequestError:
    state.prospect.updateProspectFiltersViewRequest.error,

  autoRunConditionFilterGroups: state.prospect.autoRunConditionFilterGroups,
  autoRunConditionFilterGroupsLogic:
    state.prospect.autoRunConditionFilterGroupsLogic,
  currentViewType: state?.prospect?.currentViewType,
  prospectViewIdFilter: state?.prospect?.prospectViewIdFilter,
  subscriptionPlan: state.home.subscription?.planCode,
});

const mapDispatchToProps = {
  sendGetProspectFiltersFieldsListRequest: () =>
    getProspectFiltersFieldsListRequest(),

  resetGetProspectFiltersFieldsListRequest: () =>
    resetGetProspectFiltersFieldsListRequest(),

  setProspectFilters: (payload: Partial<Filters>) => setFilters(payload),

  sendSaveProspectFiltersViewRequest: (
    payload: ProspectFiltersSaveViewPayload,
  ) => saveProspectFiltersViewRequest(payload),
  sendUpdateProspectFiltersViewRequest: (
    payload: ProspectFiltersUpdateViewPayload,
  ) => updateProspectFiltersViewRequest(payload),

  sendGetTeamsListRequest: () =>
    getTeamsRequest({
      pageNum: 1,
      pageSize: 500,
    }),

  resetSaveProspectFiltersViewRequest: () =>
    resetSaveProspectFiltersViewRequest(),
  resetUpdateProspectFiltersViewRequest: () =>
    resetUpdateProspectFiltersViewRequest(),

  sendGetContactListByViewIdRequest: (payload: ProspectListPayload) =>
    getContactListByViewIdRequest(payload),

  sendGetProspectListCountRequest: (payload: ProspectListPayload) =>
    getProspectListCountRequest(payload),

  getFilterViewListRequest: () => getFilterViewListRequest({}),

  removedSelectedSavedView: () => removedSelectedSavedView(),
  resetFilterGroupLogic: () => resetFilterGroupLogic(),
  setShouldFetchInitialList: (payload: boolean) =>
    setShouldFetchInitialList(payload),
  setProspectViewIdFilter: (payload: FilterGroupLogicPayload) =>
    setProspectViewIdFilter(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  show: boolean;
  onClose: VoidFunction;
  onApplyAiColEnrichmentAutoRunSettingsCondition?: (
    filterGroups: FilterGroup[],
    autoRunCondition: any,
    autoRunConditionLogic: any,
  ) => void | null;
  headerTitle?: string | null;
  autoRunConditionFilterGroups?: any;
  isCreateViewModal?: boolean;
};

export default connector(ProspectFiltersModal);
